/**
 * Scene marker (GIS annotation) operations for CDP SDK.
 */

import { CDPSession, getSession } from '../session';

export class MarkerManager {
  constructor(private readonly session: CDPSession = getSession()) {}

  async listMarksBySceneUuid(
    sceneUuid: string,
    page = 1,
    size = 20,
  ): Promise<Record<string, any>> {
    const params = { page, size, options: JSON.stringify({ where: { sceneUuid } }) };
    return this.session.get('/api/cdp_scene_marker/page', { params });
  }

  async addMark(data: Record<string, any>): Promise<Record<string, any>> {
    return this.session.post('/api/cdp_scene_marker/create', { data });
  }

  async updateMark(data: Record<string, any>): Promise<Record<string, any>> {
    return this.session.post('/api/cdp_scene_marker/update', { data });
  }

  async deleteMarkByUuid(markUuid: string): Promise<Record<string, any>> {
    return this.session.post(`/api/cdp_scene_marker/delete/${markUuid}`);
  }

  async batchDeleteMarkByUuid(markUuids: string[]): Promise<Record<string, any>> {
    return this.session.post('/api/cdp_scene_marker/batchDelete', { data: markUuids });
  }

  async clearMarksBySceneUuid(sceneUuid: string): Promise<Record<string, any>> {
    return this.session.post('/api/cdp_scene_marker/extend/deleteByScene', {
      params: { sceneUuid },
      data: { sceneUuid },
    });
  }

  async uploadMarkImage(formData: FormData): Promise<Record<string, any>> {
    return this.session.post('/api/editor/uploadImage', { data: formData, headers: {} });
  }
}
